import { FormControls } from '../../../../components/FormUtilities'
import Panel, { PanelBody, PanelHeader } from '../../../../components/Panel'
import Fields1 from './Fields1'
import Button from '../../../../components/Button'
import useSubmitProduct from '../../useSubmitProduct'
import { storagePage, formInformation } from '../../storage'
import EquipInfo from '../EquipInfo'
import ConsumablesInfo from '../ConsumablesInfo'
import ServicesInfo from '../ServicesInfo'
import { useState, useEffect } from 'react'

function TypeBasedPanel() {
    const [typeProductValue, setTypeProductValue] = useState<
        string | undefined
    >(formInformation.store().type_product?.value)

    useEffect(() => {
        const updateValue = () => {
            const currentValue = formInformation.store().type_product?.value
            if (currentValue !== typeProductValue) {
                setTypeProductValue(currentValue)
            }
        }
        updateValue()
        const interval = setInterval(updateValue, 100)
        return () => clearInterval(interval)
    }, [typeProductValue])

    if (typeProductValue === '0') return <EquipInfo />
    if (typeProductValue === '1') return <ConsumablesInfo />
    if (typeProductValue === '2') return <ServicesInfo />
    return null
}

export default function ProductInfo() {
    const submit = useSubmitProduct()
    return (
        <>
            <Panel mode="form">
                <PanelHeader title="Información de producto">
                    {storagePage.mode === 'edition' && (
                        <Button
                            size="sm"
                            color="accent"
                            onClick={() => submit()}
                        >
                            Guardar
                        </Button>
                    )}
                </PanelHeader>
                <Information />
            </Panel>
            <TypeBasedPanel />
        </>
    )
}

function Information() {
    return (
        <PanelBody>
            <FormControls>
                <Fields1 />
            </FormControls>
        </PanelBody>
    )
}
